import { norm, type CarnetIndex } from "./songIndex";
import { categoryForRef, categoryForTitle } from "./carnetCategories";

// Loads the parish carnet de chant index (public/data/carnet.json) once and
// caches it as a Map keyed by the normalised title, for O(1) page lookups.
let cache: CarnetIndex | null = null;
let inflight: Promise<CarnetIndex> | null = null;

export function loadCarnet(): Promise<CarnetIndex> {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    // Revalidate (not force-cache): the carnet grows across deploys, so returning
    // users must pick up newly-added songs rather than keep a stale cached copy.
    inflight = fetch("/data/carnet.json", { cache: "no-cache" })
      .then((r) => r.json())
      .then((d) => {
        const m: CarnetIndex = new Map();
        for (const s of Array.isArray(d?.songs) ? d.songs : []) {
          const k = norm(s?.title || "");
          if (k && s?.page && !m.has(k)) m.set(k, { title: s.title, page: String(s.page), ref: s.ref || undefined, cat: s.cat || categoryForRef(s.ref) || categoryForTitle(s.title) });
        }
        return (cache = m);
      })
      .catch(() => (cache = new Map()));
  }
  return inflight;
}
